import React, { useEffect } from "react";
import { createContext } from "react";
import { getCookie, setCookie } from "../../utils/cookieHelper";
import _ from "lodash";

export const UserContext = createContext({});

/**
 * @param {*} param
 * @returns <UserContext.Provider/>
 * @returns <UserContext.Consumer/>
 *
 */
function UserContextProvider({ children }) {
  const [user, setUser] = React.useState({});
  const [userAgences, setUserAgences] = React.useState([]);
  const [userAgencesList, setUserAgencesList] = React.useState("");
  const [role, setRole] = React.useState({});
  const [profil, setProfil] = React.useState({});
  const [token, setToken] = React.useState("");

  const users = {
    user,
    updateUser(newUser) {
      setUser(newUser);
    },
    token,
    updateToken(newToken) {
      setToken(newToken);
    },
    role,
    updateRole(newRole) {
      setRole(newRole);
    },
    profil,
    updateRole(newRole) {
      setProfil(newRole);
    },
    userAgences,
    updateUserAgences(newUserAgences) {
      setUserAgences(newUserAgences);
    },
    userAgencesList,
    updateUserAgencesList(newUserAgencesList) {
      setUserAgencesList(newUserAgencesList);
    },
  };

  useEffect(() => {
    // On va chercher les données de l'utilisateur dans le sessionStorage
    if (_.isEmpty(user)) {
      if (!_.isEmpty(window.sessionStorage.getItem("user"))) {
        setUser(JSON.parse(window.sessionStorage.getItem("user")));
      }
    }
    // Si le user est renseigné dans le contexte, on le stocke dans le sessionStorage
    if (
      !_.isEmpty(user) &&
      window.sessionStorage.getItem("user") !== JSON.stringify(user)
    ) {
      window.sessionStorage.setItem("user", JSON.stringify(user));
    }
    setRole(user.roles);
    setProfil(user.profil);
    setUserAgences(user.agences);
    setUserAgencesList(user.agencesList);

    // On va chercher le token dans les cookies
    if (token === "") {
      if (getCookie("token")) {
        setToken(getCookie("token"));
      }
    }
    if (token !== "" && getCookie("token") !== token) {
      setCookie("token", token, 1);
    }
  }, []);

  return <UserContext.Provider value={users}>{children}</UserContext.Provider>;
}

export default UserContextProvider;
